import { ADMIN_MODAL_ACTIONS } from "../../constants"


const initialState = {
    isModalOpen: false,
    data: {title: null, content: null}
}

const AdminModalState = (state = initialState, action) => {
    switch(action.type){
        case ADMIN_MODAL_ACTIONS.SHOW_ADMIN_MODAL:
            return {isModalOpen: true, data: {...action.payload}}
        case ADMIN_MODAL_ACTIONS.HIDE_ADMIN_MODAL:
            return {isModalOpen: false, data: {title: null, content: null}}
        default:
            return state;
    }
}

export default AdminModalState;


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_admin_alert_modal.js